export const RESERVE_COMPUTATION_TABLE_TITLE = 'Reserve Computation';
export const RESERVE_COMPUTATION_TABLE_INFO_URL = '';
